import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function SimpleSlider() {

  const brands = [
    {
      link: "https://www.facebook.com/Elmiuraveterinaria",
      brand: "El Miura",
      image: "assets/img/partners/1.png"
    },
    {
      link: "https://www.facebook.com/Corebooks",
      brand: "Corebooks",
      image: "assets/img/partners/2.png"
    },
    {
      link: "https://www.facebook.com/APDevsCompany",
      brand: "Apdevs",
      image: "assets/img/partners/3.png"
    },
    {
      link: "https://www.rookmotion.com",
      brand: "RookMotion",
      image: "assets/img/partners/4.png"
    },
  ]

  let settings = {
    dots: false,
    arrow: false,
    infinite: true,
    speed: 500,
    slidesToShow: brands.length,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <ul>
      <Slider {...settings}>

        {brands.map(brand => (
          
          <li 
            key = { brand.link }
            className="item"
            style = {{ width: "20%"}}
          >

            <a href= { brand.link } target = "_blank" rel="noopener noreferrer">
              <img src={ brand.image } alt="partners brand" />
            </a>

          </li>

        ))}

      </Slider>
    </ul>
  );
}
